import { Chip, Typography } from '@mui/material'
import { SxProps } from '@mui/system'
import { FC } from 'react'

import {
  Maybe,
  MissionLabel as EnumMissionLabel,
} from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'

type MissionLabelProps = {
  label: Maybe<EnumMissionLabel>
  sx?: SxProps
}

type MissionTextProps = {
  text: string
  sx?: SxProps
}

export const MissionLabel: FC<MissionLabelProps> = ({ label, sx }) => {
  switch (label) {
    case EnumMissionLabel.Clear:
      return (
        <Chip
          label={<MissionText text="clear" sx={{ color: 'black' }} />}
          size="small"
          sx={{
            backgroundColor: 'secondary.main',
            ...sx,
          }}
        />
      )
    case EnumMissionLabel.Expired:
      return (
        <Chip
          label={
            <MissionText text="expired" sx={{ color: 'text.secondary' }} />
          }
          size="small"
          sx={{
            backgroundColor: 'grey.100',
            ...sx,
          }}
        />
      )
    case EnumMissionLabel.New:
      return (
        <Chip
          label={<MissionText text="new" sx={{ color: 'white' }} />}
          size="small"
          sx={{
            backgroundColor: 'warning.main',
            borderRadius: '100px',
            pr: '12px',
            pl: '12px',
            height: '20px',
            ...sx,
          }}
        />
      )
    default:
      return null
  }
}

const MissionText = ({ text, sx }: MissionTextProps) => {
  const { t } = useTranslation()
  return (
    <Typography variant="subtitle2" sx={sx}>
      {t(text)}
    </Typography>
  )
}
